
<div class="image_outer" [ngStyle]="{'background-image': 'url('+getUserSiteDetails.siteBanner + ')'}">
    <div class="img_opacity"></div>
    <span id="imageText_size_header" *ngIf="getUserSiteDetails">{{getUserSiteDetails.siteName}}</span><br>
    <span id="imageText_size" *ngIf="getUserSiteDetails">{{getUserSiteDetails.siteDesc}}</span>
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>

<div *ngIf = "userLocationCode != 'DFLT'" class="container-fluid">
  <div class="row">
    <div class="col-lg-6 column">
      <!-- large screen -->
      <div *ngIf="userLocationCode != 'DFLT'" id="upcomingevents_web">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 upcoming_events_outerdiv">
              <h2 class="upcoming_events_margin">UPCOMING EVENTS</h2>
              <div id="eventlist{{i}}" class="list-group listgroup_margin" [ngClass]="{'hideDiv': i > 2}"
                *ngFor="let events of upcomingeventsinfo; let i = index" (click)="viewMoreEventsDetails(events.eventId)">
                <div *ngIf="i <= 2">
                  <div class="date_span">
                    <div class="event_day">{{events.eventDay}}</div>
                    <div class="event_monthname">{{events.eventMonth}}</div>
  
                  </div>
                  <div class="content_span_font">
                    <span class="event_name_font_weight">{{events.eventName}}</span><br>
                    <span>{{events.startTime}}</span> - <span>{{events.endTime}}</span><span><span> |
                      </span>{{events.venue}}</span><br>
                    <span>{{events.bpgName}}</span>
                  </div>
                </div>
              </div>
              <div class="upcoming_events_margin" *ngIf="upcomingeventsinfo != null && upcomingeventsinfo.length==0">
                No upcoming events available
              </div>
  
              <a class="viewmoreevents_anchor" *ngIf="upcomingeventsinfo != null && upcomingeventsinfo.length>=3"
                (click)="viewMoreEvents()">View more events >></a>
  
            </div>
          </div>
        </div>
      </div>
      <!-- small screen -->
      <div *ngIf="userLocationCode != 'DFLT'" id="upcomingevents_mob" class="marginBottom">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 upcoming_events_outerdiv"
              [ngClass]="{'hide-for-mobile': (upcomingeventsinfo != undefined && upcomingeventsinfo.length < 1)}">
              <h2 class="upcoming_events_margin">UPCOMING EVENTS</h2>
              <div id="eventlist{{i}}" class="list-group listgroup_margin" [ngClass]="{'hideDiv': i > 2}"
                *ngFor="let events of upcomingeventsinfo; let i = index" (click)="viewMoreEventsDetails(events.eventId)">
                <div *ngIf="i <= 2">
                  <div class="date_span">
                    <div class="event_day">{{events.eventDay}}</div>
                    <div class="event_monthname">{{events.eventMonth}}</div>
  
                  </div>
                  <div class="content_span_font">
                    <span class="event_name_font_weight">{{events.eventName}}</span><br>
                    <span>{{events.startTime}}</span> - <span>{{events.endTime}}</span><span><span> |
                      </span>{{events.venue}}</span><br>
                    <span>{{events.bpgName}}</span>
                  </div>
  
                </div>
              </div>
              <a class="viewmoreevents_anchor" *ngIf="upcomingeventsinfo != null && upcomingeventsinfo.length>=3"
                (click)="viewMoreEvents()">View more events >></a>
  
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 img_column">
      <div class="background_img">
        <img class ="zoom-in-style "src="assets/images/image_04.jpg" alt="Notebook" style="width:100%;">
      </div>
      <div class="img_layer"></div>

      <div class="content" >
        <h3 class="select_bpg">SELECT BPG</h3>
        <div class="dropdown dropdown_height" [ngClass]="{disabled: !selectBpgDropDownShow}">
          <button type="button" class="btn btn-dropdown dropdown-toggle btn-dropdown-styles form-control" data-toggle="dropdown">
            {{bpgName}}
          </button>
          <div class="dropdown-menu btn-dropdown-div">
            <a class="dropdown-item dropdown-a" *ngFor="let siteBpg of siteBpgList" (click)="setBpgName(siteBpg.bpgName,siteBpg.bpgId)">{{siteBpg.bpgName}}<span
                style="display:none">{{siteBpg.bpgId}}</span></a>
            <input type="text" [(ngModel)]="bpgId" name="bpgId" style="display: none">
          </div>
          <p class="noBpgs" *ngIf="!selectBpgDropDownShow">No BPG's Found</p>
        </div>
        <div class="btn-go-div">
          <button type="button" class="btn btn-go" (click)="openBpg(bpgId)" [disabled]="!bpgId">Go</button>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="paragraph-div" *ngIf="selectedBpgList.length > 0">
  <div class="btn-becomeamember-div">
    <button type="button" class="btn btn-becomeamember" [disabled]="selectedBpgList.length == 0" data-toggle="modal" data-target="#myModal"><a class="a_becomeamember" >
        WITHDRAW MEMBERSHIP</a></button>
        <app-confirmation-modal [PData]="confirmMsg" (emitPass)="withdrawMembership()"></app-confirmation-modal>                                                                                                          
  </div>
</div>




